import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#115C71",// "#FF767E",
    },
    secondary: {
      main: "#115C71",
    },
    background: {
      main: "#E7F1EA",
      primary: "#FFFFFF",
      secondary: "#FF767E",
    },
    white : {main:"#FFFFFF"}
  },
  typography: {
    //fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      mc: 1280,
      xl: 1536,
    },
  },
});

export default theme;
